import {
  AfterViewInit,
  ChangeDetectorRef,
  Component, effect,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {MediaStore} from "@cybfed/ui-lib/forms/image-input/media-gallery/media.store";
import {PopupHelperService} from "@cybfed/core/services/popup-helper.service";
import {FileUploadService} from "@cybfed/core/services/file-upload.service";
import {DecimalPipe, NgClass, NgIf} from "@angular/common";

@Component({
  selector: 'app-image-input',
  templateUrl: './image-input.component.html',
  standalone: true,
  providers: [FileUploadService],
  imports: [
    DecimalPipe,
    NgIf,
    NgClass
  ]
})
export class ImageInputComponent implements  OnInit, AfterViewInit {
  @Output() onChangeInput: EventEmitter<any> = new EventEmitter<any>();
  @Input() multiplayer: any;
  @Input() formats: any = [];
  @Input() showHeder: any;
  @Input() modalOptions: any;
  @Input() fileUploaderSize: boolean = true;
  @Input() requiredTitle: boolean = false;
  @Input() size: any
  @Input() type: any

  dragFile: boolean = false;
  showLoader: boolean = false

  value: string = '';
  selectedSize: any = null;


  constructor(private cdr: ChangeDetectorRef,
              private popupHelperService: PopupHelperService,
              public mediaLib: MediaStore) {
  }

  ngOnInit() {

  }

  ngAfterViewInit() {
  }


  onChange: any = () => {
    this.onChangeInput.emit(this.value)
  };

  writeValue(value: any): void {
    this.value = value;
    this.onChange(value);
    //this.ngModelChange.emit(value);
    this.cdr.markForCheck();
  }



  showMedia(){
    this.setConfigs()
    this.mediaLib.setImageResource = this.writeValue.bind(this);
    this.mediaLib.showMediaLib = true;
  }

  private setConfigs() {
    if (this.size) {
      this.mediaLib.size = this.size
    }
    if (this.formats) {
      this.mediaLib.formats = this.formats
    }
    if (this.showHeder || this.showHeder === false) {
      this.mediaLib.showSizes = this.showHeder;
    }
  }

  isDragging = false;

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
  }

  async onDrop(event: DragEvent): Promise<void> {
    event.preventDefault();
    event.stopPropagation();
    this.mediaLib.setImageResource = this.writeValue.bind(this);
    this.isDragging = false;
    this.dragFile = true

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      await this.handleFileUpload(files[0]);
    }
  }


  async handleFileUpload(file: any) {
    let isImage = false;
    let isVideo = false;
    const MAX_SIZE_MB = 10; // Maximum size in MB
    const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024; // Convert to bytes

    const fileType = file.type;
    const fileName = file.name.toLowerCase();

    // Improved formats check
    const isSupported = this.formats.some(format => {
      // Handle comma-separated lists (e.g., GLOBALIMAGE)
      if (format.indexOf(',') !== -1) {
        return format.split(',').some(f => f.trim() === fileType);
      }
      // Handle wildcard types (e.g., video/*, audio/*)
      if (format.endsWith('/*')) {
        const baseType = format.split('/')[0];
        return fileType.startsWith(baseType + '/');
      }
      // Handle extension-based formats (e.g., .gif)
      if (format.startsWith('.')) {
        return fileName.endsWith(format);
      }
      // Default: exact MIME type match
      return format === fileType;
    });

    if (!isSupported) {
      return this.popupHelperService.printError({
        text: "this_format_is_not_supported",
      });
    }

    if (file.size > MAX_SIZE_BYTES) {
      this.popupHelperService.printError({
        text: `File size exceeds the ${MAX_SIZE_MB} MB limit. Please upload a smaller file.`,
      });
      return;
    }

    isImage = this.isImage(file.name);
    isVideo = this.isVideo(file.name);

    if (isImage) {
      this.mediaLib.onCreate(file, true);
    } else if (isVideo) {
      this.mediaLib.getVideoSource(file, true);
    } else {
      // Handle unsupported format (should rarely reach this point)
      this.popupHelperService.printError({
        text: "This format is not supported for upload.",
      });
    }
  }




  isImage(filename:string) {
    const ext = this.getExtension(filename);
    switch (ext.toLowerCase()) {
      case 'jpg':
      case 'jpeg':
      case 'gif':
      case 'bmp':
      case 'png':
      case 'webp':
        return true;
    }
    return false;
  }

  isVideo(filename:string){
    const ext = this.getExtension(filename);
    switch (ext.toLowerCase()) {
      case 'mp4':
      case 'mp3':
      case 'm4v':
      case 'mov':
      case 'avi':
      case 'wmv':
      case 'flv':
      case 'mkv':
      case 'webm':
      case 'audio':
        return true;
      default:
        return false;
    }
  }

  getExtension(filename:string) {
    const parts = filename.split('.');
    return parts[parts.length - 1];
  }

}
